export const businessDirectoryLandingPageRoutes = [
  "/business-directory.html",
  "/de-de/firmenverzeichnis.html",
  "/de-at/firmenverzeichnis.html",
  "/de-ch/firmenverzeichnis.html",
  "/hu-hu/cegkereso.html",
  "/pl-pl/baza-firm.html",
]

export const siteSearchResultPageRoutes = [
  "/site-search-results.html",
  "/de-de/seitensuche-ergebnisse.html",
  "/de-ch/seitensuche-ergebnisse.html",
  "/de-at/seitensuche-ergebnisse.html",
  "/hu-hu/webhely-talalatok.html",
  "/pl-pl/wyniki-wyszukiwania-na-stronie.html"
]

export const companyProfilePageRoutes = [
  // "/business-directory",
  "/de-de/firmenverzeichnis",
  "/de-ch/firmenverzeichnis",
  "/de-at/firmenverzeichnis",
  "/hu-hu/cegkereso",
  "/pl-pl/baza-firm",
]

export const upikPageRoutes = [
  "/de-de/upik-en.html",
  "/de-de/upik.html",
  "/de-de/onboarding/volkswagen-en.html",
  "/de-de/onboarding/volkswagen.html",
  "/de-de/upik-en/contact-upik.html",
  "/de-de/upik/kontaktaufnahme-upik.html",
  "/de-de/upik-en/terms-of-use.html",
  "/de-de/upik/nutzungsbedingungen.html"
]
